/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname;

	// <配当金>グラフ描画
	const dividendCsvLoad = () => {
		let labelsArr, dataArr;
		const ctx = document.getElementById('myBarChart');

		const req = new XMLHttpRequest();
		req.open('get', '/ir/dividend_graph_data.csv', true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			tmp.shift(); // 見出し行削除
			tmp.forEach((val, idx) => {
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);
				if(idx === 0) {
					labelsArr = data2;
				}
				if(data2.indexOf('合計') !== -1) {
					data2.splice(0,1);
					dataArr = data2;
				}
				Chart.defaults.global.defaultFontColor = '#000';
				let myBarChart = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '合計',
							data: dataArr,
							backgroundColor: '#ffb500'
						}]
					},
					options: {
						scales: {
							yAxes: [{
								ticks: {
									suggestedMax: 30,
									suggestedMin: 0,
									stepSize: 10,
									callback: function(value, index, values){
										return  value
									}
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.3
							}]
						},
					}
				});
				
			});

		};
	}

	// <業績ハイライト>グラフ描画
	const highlightsCsvLoad = () => {
		let labelsArr,
			dataArr01, dataArr02_1, dataArr02_2, dataArr03, dataArr04_1, dataArr04_2,
			dataArr05, dataArr06_1, dataArr06_2, dataArr06_3;
		const ctx01 = document.getElementById('chart01');
		const ctx02 = document.getElementById('chart02');
		const ctx03 = document.getElementById('chart03');
		const ctx04 = document.getElementById('chart04');
		const ctx05 = document.getElementById('chart05');
		const ctx06 = document.getElementById('chart06');

		const req = new XMLHttpRequest();
		req.open('get', '/ir/highlights_graph_data.csv', true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');

			tmp.shift(); // 見出し行削除
			tmp.forEach((val, idx) => {
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);

				// 共通ラベル
				if(idx === 0) {
					data2.splice(0,2)
					data2.pop();
					labelsArr = data2;
				}
				// 売上高
				if(data2.indexOf('売上高') !== -1) {
					data2.splice(0,2)
					data2.pop();
					dataArr01 = data2;
					dataArr01.forEach((value, index, array) => {
						value = value/100;
						dataArr01[index] = value;
					});
				}
				// 営業利益・営業利益率(営業利益)
				if(data2.indexOf('営業利益') !== -1) {
					data2.splice(0,3)
					data2.pop();
					dataArr02_1 = data2;
					dataArr02_1.forEach((value, index, array) => {
						value = value/100;
						dataArr02_1[index] = value;
					});
				}
				// 営業利益・営業利益率(営業利益率（％）)
				if(data2.indexOf('営業利益率（％）') !== -1) {
					data2.splice(0,1)
					data2.pop();
					dataArr02_2 = data2;
				}
				// 経常利益
				if(data2.indexOf('経常利益') !== -1) {
					data2.splice(0,2)
					data2.pop();
					dataArr03 = data2;
					dataArr03.forEach((value, index, array) => {
						value = value/100;
						dataArr03[index] = value;
					});
				}
				// 純利益・自己資本利益率(純利益)
				if(data2.indexOf('純利益') !== -1) {
					data2.splice(0,3)
					data2.pop();
					dataArr04_1 = data2;
					dataArr04_1.forEach((value, index, array) => {
						value = value/100;
						dataArr04_1[index] = value;
					});
				}
				// 純利益・自己資本利益率(自己資本利益率（％）)
				if(data2.indexOf('自己資本利益率（％）') !== -1) {
					data2.splice(0,1)
					data2.pop();
					dataArr04_2 = data2;
				}
				// 包括利益
				if(data2.indexOf('包括利益') !== -1) {
					data2.splice(0,2)
					data2.pop();
					dataArr05 = data2;
					dataArr05.forEach((value, index, array) => {
						value = value/100;
						dataArr05[index] = value;
					});
				}

				// 総資産・純資産・自己資本比率(総資産)
				if(data2.indexOf('総資産') !== -1) {
					data2.splice(0,1)
					data2.pop();
					dataArr06_1 = data2;
					dataArr06_1.forEach((value, index, array) => {
						value = value/100;
						dataArr06_1[index] = value;
					});
				}
				// 総資産・純資産・自己資本比率(純資産)
				if(data2.indexOf('純資産') !== -1) {
					data2.splice(0,3)
					data2.pop();
					dataArr06_2 = data2;
					dataArr06_2.forEach((value, index, array) => {
						value = value/100;
						dataArr06_2[index] = value;
					});
				}
				// 総資産・純資産・自己資本比率(自己資本比率)
				if(data2.indexOf('自己資本比率（％）') !== -1) {
					data2.splice(0,1)
					data2.pop();
					dataArr06_3 = data2;
				}

				Chart.defaults.global.defaultFontColor = '#000';
				// 売上高
				let myBarChart01 = new Chart(ctx01, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '売上高',
							data: dataArr01,
							backgroundColor: '#ffb500'
						}]
					},
					options: {
						scales: {
							yAxes: [{
								ticks: {
									suggestedMax: 1400,
									suggestedMin: 0,
									stepSize: 200,
									callback: function(value, index, values){
										return  value
									}
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.5,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > 5){
											return [val.substr(0, 5), val.substr(5)]
										}else{
											return val;
										}
									}
								}
							}]
						}
					}
				});

				// 営業利益・営業利益率
				let myBarChart02 = new Chart(ctx02, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '営業利益率',
							type: "line",
							tension: 0,
							fill: false,
							data: dataArr02_2,
							borderColor: "#004098",
							yAxisID: "y-axis-1",
						},{
							label: '営業利益',
							data: dataArr02_1,
							backgroundColor: '#ffb500',
							yAxisID: "y-axis-2",
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: "y-axis-1",
								type: "linear",
								position: "right",
								ticks: {
									max: 6,
									min: 0,
									stepSize: 1,
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							},{
								id: "y-axis-2",
								type: "linear",
								position: "left",
								ticks: {
									max: 70,
									min: 0,
									stepSize: 10,
								},
								gridLines: {
									drawOnChartArea: false,
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.5,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > 5){
											return [val.substr(0, 5), val.substr(5)]
										}else{
											return val;
										}
									}
								}
							}]
						}
					}
				});

				// 経常利益
				let myBarChart03 = new Chart(ctx03, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '経常利益',
							data: dataArr03,
							backgroundColor: '#ffb500'
						}]
					},
					options: {
						scales: {
							yAxes: [{
								ticks: {
									suggestedMax: 60,
									suggestedMin: 0,
									stepSize: 10,
									callback: function(value, index, values){
										return  value
									}
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.5,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > 5){
											return [val.substr(0, 5), val.substr(5)]
										}else{
											return val;
										}
									}
								}
							}]
						}
					}
				});

				// 純利益・自己資本利益率
				let myBarChart04 = new Chart(ctx04, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '自己資本利益率',
							type: "line",
							tension: 0,
							fill: false,
							data: dataArr04_2,
							borderColor: "#004098",
							yAxisID: "y-axis-1",
						},{
							label: '純利益',
							data: dataArr04_1,
							backgroundColor: '#ffb500',
							yAxisID: "y-axis-2",
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: "y-axis-1",
								type: "linear",
								position: "right",
								ticks: {
									max: 15,
									min: 0,
									stepSize: 5
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							},{
								id: "y-axis-2",
								type: "linear",
								position: "left",
								ticks: {
									max: 50,
									min: 0,
									stepSize: 10
								},
								gridLines: {
									drawOnChartArea: false,
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.5,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > 5){
											return [val.substr(0, 5), val.substr(5)]
										}else{
											return val;
										}
									}
								}
							}]
						}
					}
				});

				// 包括利益
				let myBarChart05 = new Chart(ctx05, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '包括利益',
							data: dataArr05,
							backgroundColor: '#ffb500'
						}]
					},
					options: {
						scales: {
							yAxes: [{
								ticks: {
									suggestedMax: 50,
									suggestedMin: 0,
									stepSize: 10,
									callback: function(value, index, values){
										return  value
									}
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.5,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > 5){
											return [val.substr(0, 5), val.substr(5)]
										}else{
											return val;
										}
									}
								}
							}]
						}
					}
				});

				// 総資産・純資産・自己資本比率
				let myBarChart06 = new Chart(ctx06, {
					type: 'bar',
					data: {
						labels: labelsArr,
						datasets: [{
							label: '自己資本比率',
							type: "line",
							tension: 0,
							fill: false,
							data: dataArr06_3,
							borderColor: "#004098",
							yAxisID: "y-axis-3",
						},{
							label: '総資産',
							data: dataArr06_1,
							backgroundColor: '#ffb500',
							yAxisID: "y-axis-1",
						},{
							label: '純資産',
							data: dataArr06_2,
							backgroundColor: '#ffec00',
							yAxisID: "y-axis-2",
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: "y-axis-3",
								type: "linear",
								position: "right",
								ticks: {
									max: 100,
									min: 0,
									stepSize: 20
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							},{
								id: "y-axis-1",
								type: "linear",
								position: "left",
								ticks: {
									max: 1000,
									min: 0,
									stepSize: 200,
									title: 'aaa'
								},
								gridLines: {
									drawOnChartArea: false,
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
							},{
								id: "y-axis-2",
								type: "linear",
								position: "left",
								ticks: {
									display: false,
									max: 1000,
									min: 0,
									stepSize: 200,
									title: 'aaa'
								},
								gridLines: {
									drawOnChartArea: false,
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: "#000"
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > 5){
											return [val.substr(0, 5), val.substr(5)]
										}else{
											return val;
										}
									}
								}
							}]
						}
					}
				});
				
			});

		};
	}

	// <連結財務諸表>ページ内リンク
	const anchorScroll = () => {
		$('.js-scroll').on('click', (event) => {
			$('.js-scroll').removeClass(a);
			$(event.currentTarget).addClass(a);
			var speed = 1200;
			if(/#/.test(event.currentTarget.href)) {
				scrollToObject(event.currentTarget.href, speed);
			}
			return false;
		});
		function scrollToObject(_self, _speed){
			var hash = '#' + _self.split('#')[1];
			var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

			if(hash !== '#pagetop') {
				if(BOURBON.va.window.width < BOURBON.va.device.sp) {
					pos -= 60;
				} else {
					pos -= 155;
				}
			}

			$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
		}
	}


	// <配当金>
	if($map === '/ir/stock/dividend.html') {
		dividendCsvLoad();
	}

	// <業績ハイライト>
	if($map === '/ir/finance/highlights.html') {
		highlightsCsvLoad();
	}

	// <連結財務諸表>
	if($('.js-scroll').length) {
		anchorScroll();
	}


})(window.jQuery, window.FUNCTIONS);
